import {
  notifyAgentDescription,
  notifyAgentIceCandidate,
  dummyAction,
  notifyNoPermission,
  notifyConnectionLimitReached,
  notifyAgentDetails
} from '../../actions/signaling'
import { restartRTC } from '../../actions/app'
import { Convert } from './Convert'
import { logger } from './../utils/logger'

require('../../proto/javascript/netop_rc_base_pb')
require('../../proto/javascript/netop_rc_route_pb')
require('../../proto/javascript/netop_rc_tracing_pb')
require('../../proto/javascript/netop_rc_transport_pb')
require('../../proto/javascript/netop_rc_signaling_pb')

export class RouteMessageParser {
  constructor () {
    this.parseMap = {
      [proto.netop.rc.signaling.SignalingMessageType.OFFER_REJECTED]: (binaryMsg) => {
        const offerRejectedResponse = proto.netop.rc.signaling.OfferRejected.deserializeBinary(binaryMsg)
        const objOfferRejectedResponse = offerRejectedResponse.toObject()
        logger(' - received route [OFFER_REJECTED]', objOfferRejectedResponse.reason)

        const action = objOfferRejectedResponse.reason === proto.netop.rc.signaling.RejectReason.NO_PERMISSIONS
          ? notifyNoPermission()
          : notifyConnectionLimitReached()
        return action
      },

      [proto.netop.rc.signaling.SignalingMessageType.ANSWER]: (binaryMsg) => {
        const answer = proto.netop.rc.signaling.Answer.deserializeBinary(binaryMsg)
        const objAnswer = answer.toObject()
        logger(' - received route [ANSWER]', objAnswer.permissionsList)

        const action = notifyAgentDescription({
          agentDescription: JSON.parse(objAnswer.sdp),
          permissions: objAnswer.permissionsList,
        })
        return action
      },

      [proto.netop.rc.signaling.SignalingMessageType.ICE_CANDIDATES]: (binaryMsg) => {
        const candidatesResponse = proto.netop.rc.signaling.ICECandidates.deserializeBinary(binaryMsg)
        const objCandidatesResponse = candidatesResponse.toObject()
        const rtcICECandidateInit = Convert.signalingMessageICECandidate2RTCIceCandidateInit(objCandidatesResponse)
        logger(' - received route [ICE_CANDIDATES]')
        const action = notifyAgentIceCandidate(rtcICECandidateInit)

        return action
      },

      [proto.netop.rc.signaling.SignalingMessageType.DETAILS_RESPONSE]: (binaryMsg) => {
        const detailsResponse = proto.netop.rc.signaling.AgentDetailsResponse.deserializeBinary(binaryMsg)
        const { agentDetails } = detailsResponse.toObject()
        logger(' - received route [DETAILS_RESPONSE]', agentDetails)
        const action = notifyAgentDetails({ agentDetails })

        return action
      },

      [proto.netop.rc.signaling.SignalingMessageType.RESTART_RTC_REQUEST]: () => {
        logger(' - received route [RESTART_RTC_REQUEST]')
        return restartRTC()
      },
    }
  }

  default = (type) => () => {
    // ignore silently the messages with unknown type
    logger(` - unknown route message type ${type}`)

    return dummyAction()
  }

  parse = (binaryMsg) => {
    const msg = proto.netop.rc.route.RouteMessage.deserializeBinary(binaryMsg)
    const body = msg.getBody()
    const signalingMsg = proto.netop.rc.signaling.SignalingMessage.deserializeBinary(body)
    const type = signalingMsg.getSignalingMessageType()
    logger(` - route msg received ${type}`)
    const parser = this.parseMap[type] || this.default(type)
    return parser(body)
  }
}
